import forEach from 'lodash/forEach'

export const handleOnAreaTotalChange = ({ value, formRef }) => {
  if ('agricultural_inputs' in formRef.current?.getData()) {
    const { agricultural_inputs: agriculturalInputs } = formRef.current.getData()


    forEach(agriculturalInputs, (rawMaterial, rawMaterialIndex) => {
      const {
        recommendation_per_hectare: recommendationPerHectare
      } = rawMaterial

      formRef.current.setFieldValue(
        `agricultural_inputs[${ rawMaterialIndex }].quant_total`,
        (Number(value) * Number(recommendationPerHectare)).toString()
      )
    })
  }

  if (formRef.current?.getFieldRef('total_syrup')) {
    const { area_total: areaTotal, volume_syrup: volumeSyrup } = formRef.current.getData()

    formRef.current.setFieldValue('total_syrup', (Number(volumeSyrup) * Number(areaTotal)).toString())
  }
}

export const handleOnRecommendationPerHectareChange = ({ value, formRef, fieldName, loading }) => {
  if (!loading && formRef.current?.getFieldRef(fieldName)) {
    const areaTotal = formRef.current.getFieldValue('area_total')

    formRef.current.setFieldValue(fieldName, (Number(value) * Number(areaTotal)).toString())
  }
}

export const handleOnSyrupVolumeChange = ({ value, formRef, loading }) => {
  if (!loading && formRef.current?.getFieldRef('total_syrup')) {
    const areaTotal = formRef.current.getFieldValue('area_total')

    formRef.current.setFieldValue('total_syrup', (Number(value) * Number(areaTotal)).toString())
  }
}
